module.exports = __webpack_public_path__ + "img/19_f.1922daf7.jpg";